import React from 'react'
import Text from '../../../../atoms/Text'
import { useListClientStatusReports } from '../../../../../api/groups'
import SydLinkButton from '../../../../commonDesign/LinkButton'
import { ADMIN_ROUTES } from '../../../../../constants'
import OpalPresentationTable from '../../../../organisms/DenaliAnalysis/tables/presentation'
import { useFormattingContext } from '../../../../organisms/FormattingProvider/FormattingContext'

function StatusReportsAssignmentsIndex () {
  const { formatter } = useFormattingContext()

  const { data, isLoading } = useListClientStatusReports({
    filters: {
      isActiveAssignment: true
    }
  }, {
    select: (data) => data.statusReports
  })

  const columns = [
    { accessorKey: 'levelName', header: 'Level Name' },
    {
      accessorKey: 'statusTemplateName',
      header: 'Template',
      cell: ({ getValue, row }) => (
        <div className='flex gap-2 items-center'>
          <span>{getValue()}</span>
          <span className='rounded bg-neutral-300 radius-md px-2 p-1'>
            {row.original.statusTemplatePurposeKey}
          </span>
        </div>
      )
    },
    {
      accessorKey: 'asOfDate',
      header: 'As Of Date',
      cell: ({ getValue }) => formatter(getValue(), '@MM/DD/YY')
    },
    {
      accessorKey: 'statusReportAssignmentId',
      header: 'Actions',
      width: '60px',
      cell: ({ row }) => {
        const { levelId, statusTemplateId } = row.original
        if (!statusTemplateId) return null
        return (
          <SydLinkButton
            to={`${ADMIN_ROUTES.STATUS_REPORTS.ASSIGNMENTS.HOME}/${statusTemplateId}/${levelId}`}
            variant='primary'
            size='sm'
          >
            Manage
          </SydLinkButton>
        )
      }
    }
  ]

  return (
    <div className='w-full flex-col gap-2 p-5 px-15'>
      <Text text='Status Report Assignments' variant='h1' className='pb-2' />

      <div className='w-full flex-col gap-2 p-5 px-0'>
        <OpalPresentationTable
          includeFooter
          includeHeader
          data={data || []}
          columns={columns}
          isLoading={isLoading}
        />
      </div>
    </div>
  )
}

export default StatusReportsAssignmentsIndex
